import React from "react"

const Input = ({ style }) => (
  <svg
    style={style}
    width="301"
    height="235"
    viewBox="0 0 301 235"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.15"
      d="M54.5 53L103.5 138M54.5 53L146 114.5M54.5 53L201.5 110M54.5 53L172.5 19.5M103.5 138L92 181.5L146 195.5M103.5 138L146 195.5M103.5 138L146 114.5M103.5 138L80.5 114.5M146 195.5V114.5M146 195.5L209 212M146 195.5L121.5 234.5M146 114.5L201.5 110M146 114.5L209 212M146 114.5L249 145.5M201.5 110L249 145.5M201.5 110L190.5 88.5M209 212L286 199L249 145.5M209 212L249 145.5M209 212L262 224.5M249 145.5L300.5 130.5"
      stroke="#254158"
    />
    <g filter="url(#filter0z_i)">
      <circle
        cx="50.4999"
        cy="50.4999"
        r="35.0729"
        fill="url(#paint0z_linear)"
      />
    </g>
    <circle
      cx="50.4999"
      cy="50.4999"
      r="40.2865"
      stroke="#9DD0FF"
      stroke-opacity="0.5"
      stroke-width="4.73958"
    />
    <circle
      cx="50.5"
      cy="50.5"
      r="47.8698"
      stroke="#9DD0FF"
      stroke-opacity="0.25"
      stroke-width="4.73958"
    />
    <g filter="url(#filter1z_i)">
      <path
        d="M50.9738 26.802C38.1479 26.802 27.75 37.1999 27.75 50.0261C27.75 62.8528 38.1479 73.2499 50.9738 73.2499C63.8011 73.2499 74.1979 62.8528 74.1979 50.0261C74.1979 37.2007 63.8011 26.8031 50.9735 26.8031L50.9738 26.802ZM61.6241 60.2978C61.2081 60.98 60.3152 61.1964 59.6329 60.7776C54.1802 57.4469 47.3159 56.6925 39.232 58.5395C38.453 58.717 37.6765 58.2289 37.499 57.4496C37.3207 56.6703 37.8068 55.8938 38.5878 55.7163C47.4344 53.6952 55.0227 54.5654 61.1443 58.3066C61.8266 58.7254 62.0429 59.6156 61.6241 60.2978ZM64.4667 53.9742C63.9425 54.8261 62.8277 55.0951 61.9763 54.571C55.7338 50.7338 46.218 49.6226 38.8343 51.864C37.8767 52.1532 36.8653 51.6135 36.5747 50.6576C36.2863 49.7 36.8262 48.6905 37.7821 48.3993C46.2164 45.8401 56.7016 47.0798 63.8704 51.4851C64.7218 52.0093 64.9908 53.1239 64.4667 53.9742ZM64.7107 47.3893C57.2258 42.9434 44.8766 42.5346 37.7303 44.7036C36.5827 45.0516 35.3692 44.4038 35.0214 43.2562C34.6736 42.1081 35.3209 40.8953 36.4693 40.5464C44.6728 38.056 58.3101 38.5372 66.9276 43.6531C67.962 44.2657 68.3004 45.5988 67.6875 46.6296C67.0774 47.6619 65.7407 48.0021 64.7118 47.3893H64.7107Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter2_i)">
      <circle cx="148" cy="195" r="23.125" fill="url(#paint1_linear)" />
    </g>
    <circle
      cx="148"
      cy="195"
      r="26.5625"
      stroke="#9DD0FF"
      stroke-opacity="0.5"
      stroke-width="3.125"
    />
    <circle
      cx="148"
      cy="195"
      r="31.5625"
      stroke="#9DD0FF"
      stroke-opacity="0.25"
      stroke-width="3.125"
    />
    <g filter="url(#filter3_i)">
      <path
        d="M143.469 200.234V187.031L155.656 185V198.203"
        stroke="white"
        stroke-width="1.93452"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M140.422 203.281C142.105 203.281 143.469 201.917 143.469 200.234C143.469 198.552 142.105 197.188 140.422 197.188C138.739 197.188 137.375 198.552 137.375 200.234C137.375 201.917 138.739 203.281 140.422 203.281Z"
        stroke="white"
        stroke-width="1.93452"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M152.609 201.25C154.292 201.25 155.656 199.886 155.656 198.203C155.656 196.52 154.292 195.156 152.609 195.156C150.927 195.156 149.562 196.52 149.562 198.203C149.562 199.886 150.927 201.25 152.609 201.25Z"
        stroke="white"
        stroke-width="1.93452"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <g opacity="0.7">
      <g filter="url(#filter4_i)">
        <circle
          r="5"
          transform="matrix(-1 0 0 1 145 115)"
          fill="url(#paint2_linear)"
        />
      </g>
      <circle
        cx="145"
        cy="115"
        r="8"
        stroke="#9DD0FF"
        stroke-opacity="0.5"
        stroke-width="2"
      />
      <circle
        cx="145"
        cy="115"
        r="12"
        stroke="#9DD0FF"
        stroke-opacity="0.25"
        stroke-width="2"
      />
    </g>
    <g opacity="0.7">
      <g filter="url(#filter5_i)">
        <circle
          r="5"
          transform="matrix(-1 0 0 1 92 181)"
          fill="url(#paint3_linear)"
        />
      </g>
      <circle
        cx="92"
        cy="181"
        r="8"
        stroke="#9DD0FF"
        stroke-opacity="0.5"
        stroke-width="2"
      />
      <circle
        cx="92"
        cy="181"
        r="12"
        stroke="#9DD0FF"
        stroke-opacity="0.25"
        stroke-width="2"
      />
    </g>
    <g opacity="0.7">
      <g filter="url(#filter6_i)">
        <circle
          r="5"
          transform="matrix(-1 0 0 1 209 212)"
          fill="url(#paint4_linear)"
        />
      </g>
      <circle
        cx="209"
        cy="212"
        r="8"
        stroke="#9DD0FF"
        stroke-opacity="0.5"
        stroke-width="2"
      />
      <circle
        cx="209"
        cy="212"
        r="12"
        stroke="#9DD0FF"
        stroke-opacity="0.25"
        stroke-width="2"
      />
    </g>
    <g opacity="0.5">
      <g filter="url(#filter7_i)">
        <circle
          r="3"
          transform="matrix(-1 0 0 1 201 110)"
          fill="url(#paint5_linear)"
        />
      </g>
      <circle
        cx="201"
        cy="110"
        r="5"
        stroke="#9DD0FF"
        stroke-opacity="0.3"
        stroke-width="2"
      />
    </g>
    <g opacity="0.5">
      <g filter="url(#filter8_i)">
        <circle
          r="3"
          transform="matrix(-1 0 0 1 103 138)"
          fill="url(#paint6_linear)"
        />
      </g>
      <circle
        cx="103"
        cy="138"
        r="5"
        stroke="#9DD0FF"
        stroke-opacity="0.3"
        stroke-width="2"
      />
    </g>
    <g opacity="0.5">
      <g filter="url(#filter9_i)">
        <circle
          r="3"
          transform="matrix(-1 0 0 1 286 199)"
          fill="url(#paint7_linear)"
        />
      </g>
      <circle
        cx="286"
        cy="199"
        r="5"
        stroke="#9DD0FF"
        stroke-opacity="0.3"
        stroke-width="2"
      />
    </g>
    <g filter="url(#filter10_i)">
      <circle cx="248.5" cy="144.5" r="28.9062" fill="url(#paint8_linear)" />
    </g>
    <circle
      cx="248.5"
      cy="144.5"
      r="33.2031"
      stroke="#9DD0FF"
      stroke-opacity="0.5"
      stroke-width="3.90625"
    />
    <circle
      cx="248.5"
      cy="144.5"
      r="39.4531"
      stroke="#9DD0FF"
      stroke-opacity="0.25"
      stroke-width="3.90625"
    />
    <path
      d="M230.15 143.666C230.064 143.666 229.992 143.738 229.981 143.836L229.581 147.551L229.981 151.184C229.992 151.281 230.064 151.352 230.15 151.352C230.236 151.352 230.306 151.282 230.32 151.184L230.773 147.551L230.32 143.834C230.305 143.736 230.236 143.666 230.15 143.666ZM228.648 145.09C228.563 145.09 228.496 145.157 228.485 145.252L228.188 147.551L228.485 149.81C228.496 149.904 228.563 149.971 228.648 149.971C228.731 149.971 228.797 149.904 228.811 149.81L229.162 147.551L228.811 145.252C228.797 145.157 228.731 145.09 228.648 145.09ZM231.745 142.938C231.638 142.938 231.553 143.023 231.542 143.142L231.163 147.551L231.542 151.797C231.553 151.916 231.638 152.001 231.745 152.001C231.851 152.001 231.936 151.916 231.95 151.799L232.38 147.551L231.95 143.142C231.936 143.023 231.851 142.938 231.745 142.938ZM233.354 142.783C233.228 142.783 233.126 142.886 233.117 143.022L232.758 147.551L233.117 151.934C233.126 152.07 233.228 152.172 233.354 152.172C233.48 152.172 233.582 152.069 233.593 151.934L234 147.551L233.593 143.02C233.583 142.886 233.48 142.783 233.354 142.783ZM235.249 143.347C235.24 143.192 235.122 143.075 234.977 143.075C234.83 143.075 234.713 143.192 234.704 143.35L234.366 147.551L234.704 151.97C234.713 152.126 234.83 152.245 234.977 152.245C235.122 152.245 235.24 152.126 235.249 151.97L235.634 147.551L235.249 143.347ZM236.613 140.406C236.448 140.406 236.313 140.542 236.306 140.717L235.988 147.554L236.306 151.971C236.313 152.144 236.448 152.281 236.613 152.281C236.774 152.281 236.909 152.143 236.92 151.97V151.971L237.278 147.554L236.92 140.716C236.909 140.542 236.774 140.406 236.613 140.406ZM238.236 138.83C238.051 138.83 237.901 138.984 237.893 139.177L237.596 147.578L237.893 151.968C237.901 152.16 238.051 152.313 238.236 152.313C238.417 152.313 238.569 152.159 238.577 151.967V151.968L238.914 147.578L238.577 139.177C238.569 138.984 238.417 138.83 238.236 138.83ZM239.922 138.072C239.717 138.072 239.552 138.239 239.545 138.454L239.268 147.556L239.545 151.9C239.552 152.112 239.718 152.279 239.922 152.279C240.124 152.279 240.29 152.112 240.298 151.899V151.902L240.61 147.556L240.298 138.454C240.29 138.239 240.124 138.072 239.922 138.072ZM242.008 138.148C242 137.914 241.82 137.73 241.596 137.73C241.371 137.73 241.19 137.914 241.185 138.148L240.928 147.556L241.185 151.875C241.187 151.985 241.231 152.091 241.307 152.168C241.384 152.246 241.488 152.289 241.596 152.289C241.82 152.289 242 152.106 242.008 151.872L242.296 147.556L242.008 138.148ZM243.283 137.936C243.04 137.936 242.842 138.135 242.838 138.388L242.602 147.556L242.838 151.834C242.842 152.085 243.04 152.285 243.283 152.285C243.527 152.285 243.722 152.085 243.73 151.831V151.836L243.994 147.556L243.73 138.388C243.722 138.135 243.527 137.936 243.283 137.936ZM244.984 138.236C244.72 138.236 244.509 138.451 244.503 138.725L244.289 147.557L244.504 151.807C244.509 152.077 244.72 152.292 244.983 152.292C245.247 152.292 245.46 152.077 245.464 151.804V151.807L245.706 147.558L245.464 138.723C245.464 138.594 245.413 138.47 245.323 138.379C245.233 138.288 245.111 138.236 244.984 138.236ZM246.982 136.611C246.898 136.554 246.799 136.523 246.698 136.523C246.596 136.523 246.5 136.554 246.419 136.608C246.347 136.656 246.288 136.721 246.247 136.797C246.206 136.873 246.184 136.959 246.183 137.046L246.18 137.146L245.987 147.555C245.987 147.562 246.183 151.78 246.183 151.78V151.797C246.189 151.916 246.232 152.025 246.304 152.11C246.352 152.17 246.412 152.218 246.48 152.251C246.548 152.284 246.622 152.301 246.698 152.302C246.838 152.302 246.965 152.242 247.058 152.147C247.151 152.052 247.21 151.922 247.213 151.778L247.235 151.359L247.43 147.557L247.213 137.046C247.212 136.96 247.19 136.876 247.15 136.8C247.109 136.725 247.052 136.66 246.982 136.611ZM247.213 151.78V151.777L247.213 151.778L247.213 151.78ZM248.684 135.616C248.588 135.556 248.476 135.528 248.363 135.537C248.251 135.545 248.144 135.59 248.057 135.663C247.995 135.716 247.944 135.781 247.909 135.855C247.874 135.93 247.855 136.011 247.854 136.093L247.853 136.152L247.628 147.559L247.743 149.667L247.855 151.72C247.858 152.023 248.105 152.275 248.404 152.275C248.703 152.275 248.95 152.023 248.955 151.716V151.72L249.198 147.559L248.955 136.093C248.953 135.997 248.927 135.903 248.88 135.819C248.832 135.736 248.765 135.666 248.684 135.616ZM263.816 142.132C263.131 142.132 262.478 142.273 261.883 142.527C261.485 137.941 257.709 134.344 253.104 134.344C252.01 134.345 250.926 134.551 249.906 134.951C249.529 135.099 249.429 135.253 249.425 135.55V151.703C249.429 152.014 249.667 152.256 249.965 152.286C249.977 152.288 263.816 152.286 263.816 152.286C266.576 152.286 268.812 150.034 268.812 147.222C268.812 144.411 266.576 142.132 263.816 142.132Z"
      fill="white"
    />
    <g opacity="0.7">
      <rect
        x="114"
        y="156.316"
        width="12.6316"
        height="2"
        rx="1"
        transform="rotate(-90 114 156.316)"
        fill="#008BFF"
      />
      <rect
        x="129"
        y="156.316"
        width="12.6316"
        height="2"
        rx="1"
        transform="rotate(-90 129 156.316)"
        fill="#008BFF"
      />
      <rect
        x="132"
        y="153.947"
        width="7.89474"
        height="2"
        rx="1"
        transform="rotate(-90 132 153.947)"
        fill="#008BFF"
      />
      <rect
        x="135"
        y="157.895"
        width="15.7895"
        height="2"
        rx="1"
        transform="rotate(-90 135 157.895)"
        fill="#008BFF"
      />
      <rect
        x="138"
        y="152.368"
        width="4.73684"
        height="2"
        rx="1"
        transform="rotate(-90 138 152.368)"
        fill="#008BFF"
      />
      <rect
        x="141"
        y="151.579"
        width="3.15789"
        height="2"
        rx="1"
        transform="rotate(-90 141 151.579)"
        fill="#008BFF"
      />
      <rect
        x="144"
        y="153.158"
        width="6.31579"
        height="2"
        rx="1"
        transform="rotate(-90 144 153.158)"
        fill="#008BFF"
      />
      <rect
        x="147"
        y="152.368"
        width="4.73684"
        height="2"
        rx="1"
        transform="rotate(-90 147 152.368)"
        fill="#008BFF"
      />
      <rect
        x="150"
        y="151.579"
        width="3.15789"
        height="2"
        rx="1"
        transform="rotate(-90 150 151.579)"
        fill="#008BFF"
      />
      <rect
        x="111"
        y="160"
        width="20"
        height="2"
        rx="1"
        transform="rotate(-90 111 160)"
        fill="#008BFF"
      />
      <rect
        x="117"
        y="162.632"
        width="25.2632"
        height="2"
        rx="1"
        transform="rotate(-90 117 162.632)"
        fill="#008BFF"
      />
      <rect
        x="120"
        y="161.842"
        width="23.6842"
        height="2"
        rx="1"
        transform="rotate(-90 120 161.842)"
        fill="#008BFF"
      />
      <rect
        x="123"
        y="165"
        width="30"
        height="2"
        rx="1"
        transform="rotate(-90 123 165)"
        fill="#008BFF"
      />
      <rect
        x="126"
        y="162.632"
        width="25.2632"
        height="2"
        rx="1"
        transform="rotate(-90 126 162.632)"
        fill="#008BFF"
      />
      <rect
        x="96"
        y="153.316"
        width="6.31579"
        height="2"
        rx="1"
        transform="rotate(-90 96 153.316)"
        fill="#008BFF"
      />
      <rect
        x="99"
        y="156"
        width="12"
        height="2"
        rx="1"
        transform="rotate(-90 99 156)"
        fill="#008BFF"
      />
      <rect
        x="102"
        y="161.842"
        width="23.6842"
        height="2"
        rx="1"
        transform="rotate(-90 102 161.842)"
        fill="#008BFF"
      />
      <rect
        x="105"
        y="160"
        width="20"
        height="2"
        rx="1"
        transform="rotate(-90 105 160)"
        fill="#008BFF"
      />
      <rect
        x="108"
        y="158"
        width="16"
        height="2"
        rx="1"
        transform="rotate(-90 108 158)"
        fill="#008BFF"
      />
    </g>
    <rect
      opacity="0.8"
      x="182.478"
      y="28.9851"
      width="96.5373"
      height="6.89552"
      rx="2.29851"
      fill="#595A5D"
    />
    <rect
      opacity="0.6"
      x="182.478"
      y="40.4777"
      width="96.5373"
      height="6.89552"
      rx="2.29851"
      fill="#595A5D"
    />
    <rect
      opacity="0.4"
      x="182.478"
      y="51.9701"
      width="96.5373"
      height="6.89552"
      rx="2.29851"
      fill="#595A5D"
    />
    <rect
      opacity="0.2"
      x="182.478"
      y="63.4626"
      width="96.5373"
      height="6.89552"
      rx="2.29851"
      fill="#595A5D"
    />
    <rect
      x="169.836"
      y="17.4926"
      width="109.179"
      height="6.89552"
      rx="2.29851"
      fill="#595A5D"
    />
    <path
      d="M274.673 78.9137C283.7 78.9137 291.018 71.5958 291.018 62.5688C291.018 53.5417 283.7 46.2239 274.673 46.2239C265.646 46.2239 258.328 53.5417 258.328 62.5688C258.328 71.5958 265.646 78.9137 274.673 78.9137Z"
      stroke="#71767E"
      stroke-width="4.08623"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M295.105 83.0001L286.217 74.1125"
      stroke="#71767E"
      stroke-width="4.08623"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M149.793 25.0901H148.248L149.117 23.6558H150.593L151.31 22.2905H149.71L150.386 20.939H152.041L153.475 18.3463H154.758L153.351 20.939H154.813L156.219 18.3463H157.502L156.095 20.939H157.557L156.854 22.2905H155.351L154.633 23.6558H156.288L155.378 25.0901H153.847L152.192 28.1517H150.896L152.537 25.0901H151.103L149.42 28.1517H148.152L149.793 25.0901ZM153.337 23.6558L154.082 22.2905H152.606L151.861 23.6558H153.337ZM161.149 16.0707C160.414 16.4998 159.686 16.7756 158.966 16.8982L159.15 14.4158C159.686 14.3086 160.314 14.0021 161.035 13.4964C161.755 12.9754 162.268 12.4468 162.575 11.9104H164.827L161.977 28H159.035L161.149 16.0707Z"
      fill="#A7A7A7"
    />
    <defs>
      <filter
        id="filter0z_i"
        x="15.427"
        y="15.427"
        width="70.1458"
        height="70.1458"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.89583" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter1z_i"
        x="27.75"
        y="26.802"
        width="46.4479"
        height="46.4479"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.473958" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter2_i"
        x="124.875"
        y="171.875"
        width="46.25"
        height="46.25"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter3_i"
        x="136.408"
        y="184.033"
        width="20.2158"
        height="20.2158"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.77381" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter4_i"
        x="140"
        y="110"
        width="10"
        height="10"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter5_i"
        x="87"
        y="176"
        width="10"
        height="10"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter6_i"
        x="204"
        y="207"
        width="10"
        height="10"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter7_i"
        x="198"
        y="107"
        width="6"
        height="6"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter8_i"
        x="100"
        y="135"
        width="6"
        height="6"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter9_i"
        x="283"
        y="196"
        width="6"
        height="6"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="filter10_i"
        x="219.594"
        y="115.594"
        width="57.8125"
        height="57.8125"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1.5625" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
      </filter>
      <linearGradient
        id="paint0z_linear"
        x1="50.4999"
        y1="15.427"
        x2="50.4999"
        y2="85.5728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="148"
        y1="171.875"
        x2="148"
        y2="218.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="5"
        y1="0"
        x2="5"
        y2="10"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="5"
        y1="0"
        x2="5"
        y2="10"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="5"
        y1="0"
        x2="5"
        y2="10"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="3"
        y1="0"
        x2="3"
        y2="6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="3"
        y1="0"
        x2="3"
        y2="6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear"
        x1="3"
        y1="0"
        x2="3"
        y2="6"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear"
        x1="248.5"
        y1="115.594"
        x2="248.5"
        y2="173.406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9DD0FF" />
        <stop offset="1" stop-color="#008BFF" />
      </linearGradient>
    </defs>
  </svg>
)

export default Input
